import { render } from "./ReversalTable.vue?vue&type=template&id=63b699cc&scoped=true"
import script from "./ReversalTable.vue?vue&type=script&lang=js"
export * from "./ReversalTable.vue?vue&type=script&lang=js"

import "./ReversalTable.vue?vue&type=style&index=0&id=63b699cc&scoped=true&lang=css"

import exportComponent from "/home/aaicom7/repositories/prod/AAI-FMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b699cc"]])

export default __exports__